import i18n from '@/locale';
import * as echarts from 'echarts';

[
  'chalk',
  'dark',
  'infographic',
  'macarons',
  'shine',
  'v5',
  'walden',
  'westeros',
].forEach(theme_name => echarts.registerTheme(theme_name, require(`@/assets/echarts/theme/${theme_name}.json`)));

echarts.registerMap('world_geo', {geoJSON: require('@/assets/echarts/geoMap/world.geojson')});

export function create_grid({
  left = '0%',
  right = '0%',
  top = '0%',
  bottom = '0%',
} = {}){
  return {
    grid: {
      show: false,
      left,
      right,
      top,
      bottom,
    },
  };
}

export function create_legend(data){
  return {
    legend: {
      textStyle: {...append_tooltip_textStyle()},
      icon: 'circle',
      data,
    },
  };
}

export function create_rich(){
  return {
    rich: {
      fmt_title: {
        ...append_tooltip_textStyle(),
        color: '#fff',
        textShadow: '0.25px 0.25px 0.5px #FFF',
      },
      fmt_value: {
        ...append_tooltip_textStyle(),
        color: '#ffc964',
        textShadow: '0.25px 0.25px 0.5px #c8e6c9',
      },
      fmt_percent: {color: '#FFF'},
    },
  };
}

export function create_tooltip({
  order = 'seriesAsc',
  number_format,
} = {}){
  return {
    tooltip: {
      ...append_tooltip_style_dark(),
      trigger: 'axis',
      order,
      valueFormatter: value => g_number_2_text(value, number_format),
    },
  };
}

export function format_tooltip_number(value, number_format){
  if(value === undefined || value === null || !Number.isFinite(value))
    return '--';
  return g_number_2_text(value, number_format);
}

export function build_tooltip_row(label, value){
  return `<div style="display:flex;justify-content:space-between;gap:24px;"><span>${label}</span><span>${value}</span></div>`;
}

export function build_tooltip_growth_row(growth_helper, growth_value){
  return build_tooltip_row(
    growth_helper.growth_label,
    `<span style="color:${growth_helper.get_growth_color(growth_value)}">${growth_helper.get_growth_text(growth_value)}</span>`,
  );
}

export function get_tooltip_position_within_view(point, params, dom, rect, size){
  const tooltip_padding = 8;
  const [point_x = 0, point_y = 0] = point || [];
  const [view_width = 0, view_height = 0] = size?.viewSize || [];
  const [content_width = 0, content_height = 0] = size?.contentSize || [];
  const x_max = Math.max(view_width - content_width - tooltip_padding, tooltip_padding);
  const y_max = Math.max(view_height - content_height - tooltip_padding, tooltip_padding);
  const x = Math.min(Math.max(point_x + tooltip_padding, tooltip_padding), x_max);
  const y = Math.min(Math.max(point_y + tooltip_padding, tooltip_padding), y_max);
  return [x, y];
}

export function append_series_area(){
  return {
    ...append_series_line(),
    stack: 'Total',
    areaStyle: {},
    emphasis: {focus: 'series'},
  };
}

export function append_series_bar(){
  return {
    type: 'bar',
    stack: 'Total',
    emphasis: {focus: 'series'},
  };
}

export function append_bar_emphasis({shadowBlur = 10, shadowColor = 'rgba(0, 0, 0, 0.5)'} = {}){
  return {
    emphasis: {
      focus: 'series',
      itemStyle: {
        shadowBlur,
        shadowColor,
      },
    },
  };
}

export function append_series_line(){
  return {
    type: 'line',
    smooth: 0.3,
    showSymbol: false,
    // itemStyle: {opacity: 0},
  };
}

export function append_tooltip_textStyle(){
  return {
    color: '#FFF',
    fontSize: 14,
    fontWeight: 1000,
  };
}

export function append_tooltip_style_dark(){
  return {
    backgroundColor: 'rgba(50, 50, 50, 0.5)',
    // 2. 移除預設邊框或設置與主題相符的顏色
    borderColor: '#333',
    borderWidth: 0,
    // 3. 設置文字顏色為白色（或淺灰色）
    textStyle: {...append_tooltip_textStyle()},
    // 可選：自定義陰影效果讓懸浮層更有層次感
    extraCssText: 'box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);',
  };
}

export function append_xAxis_timeline(){
  return {
    type: 'category',
    axisLabel: {color: '#FFF'},
    axisTick: {show: false},
    boundaryGap: false,
  };
}

export function append_yAxis_timeline(){
  return {
    type: 'value',
    show: false,
    axisTick: {show: false},
    splitLine: {show: false},
  };
}
